export default "__VITE_ASSET__058c3ef0__"